import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const stackedBarGraphDescription: CalculatorDescription = {
  id: CalculatorId.StackedBarChart,
  title: 'Stacked Bar Chart Creator',
  metaTitle: 'Online Stacked Bar Chart Maker - Create Layered Graphs',
  description: 'Create stacked bar charts to show composition of categories and their total values. Perfect for comparing both total amounts and their components.',
  metaDescription: 'Make stacked bar charts online. Create layered bar graphs with our free tool. Compare totals and components across categories.',
  howTo: {
    title: 'How to Create a Stacked Bar Chart',
    steps: [
      'Enter categories and subcategories',
      'Input values for each component',
      'Choose color scheme',
      'Configure stack order',
      'Add legends and labels'
    ],
    graphic: {
      description: 'An echarts stacked bar chart with multiple layers, plus a shadcn grid for hierarchical data entry'
    }
  },
  examples: [
    {
      title: 'Sales Composition',
      description: 'Multi-product sales data',
      dataDescription: 'Shows total revenue by region',
      insights: [
        'Shows total revenue by region',
        'Displays product mix',
        'Highlights contribution ratios'
      ]
    },
    {
      title: 'Population Demographics',
      description: 'Age group data',
      dataDescription: 'Shows total population by area',
      insights: [
        'Shows total population by area',
        'Displays age distribution',
        'Identifies demographic patterns'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BarGraph,
    CalculatorId.StackedBarChart,
    CalculatorId.PieChart
  ]
}; 